import { render } from "./PatchnoteSection.vue?vue&type=template&id=ea687232&scoped=true&ts=true&lang=pug"
import script from "./PatchnoteSection.vue?vue&type=script&lang=ts"
export * from "./PatchnoteSection.vue?vue&type=script&lang=ts"

import "./PatchnoteSection.vue?vue&type=style&index=0&id=ea687232&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea687232"]])

export default __exports__